<template>
  <div>
    <v-row>
      <v-col cols="12">
        <validation-provider v-slot="{ errors }" rules="required">
          <v-text-field
            id="titulo-movimentacao-blindada"
            v-model="titulo"
            class="my-0"
            label="Título*"
            outlined
            :error-messages="errors"
          />
        </validation-provider>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="my-0 pt-0">
        <v-alert dense outlined type="info" class="mb-0 px-1 py-0">
          IPCA oficial atualizados até:
          <b>{{ dataUltimoIpcaOficial | formatToMonth }}</b>
          ({{ mesesSemAtualizarIpcaOficial }} meses sem atualizar)
          <br />
          <template v-if="dataUltimoIpcaNaoOficial">
            IPCA estimado atualizados até:
            <b>{{ dataUltimoIpcaNaoOficial | formatToMonth }}</b>
          </template>
        </v-alert>
      </v-col>
    </v-row>
    <v-row>
      <v-col id="date-picker-data-corte-ultimo-ciclo" cols="6">
        <date-picker
          v-model="anoMesCorteUltimoCiclo"
          label="Data de Corte do Último Ciclo*"
          type="month"
          rules="required|min:10"
          hint="Informe uma database de um laudo blindado importado"
          persistent-hint
          outlined
          @change="clearSimulacaoBaixas()"
          @click:clear="clearSimulacaoBaixas()"
        />
      </v-col>
      <v-col id="date-picker-data-homologacao" cols="6">
        <date-picker
          v-model="dataHomologacao"
          label="Data de Homologação (Opcional)"
          type="month"
          :rules="dataHomologacao && dataHomologacaoValida ? 'required' : 'forcar_erro'"
          outlined
          @change="checkAtualizarDesdeInput()"
        />
      </v-col>
    </v-row>
    <v-row id="date-picker-data-atualizacao">
      <v-col cols="6">
        <validation-provider v-slot="{ errors }" rules="required">
          <v-select
            v-model="atualizarDesde"
            label="Atualizar Desde*"
            :items="atualizarDesdeList"
            item-value="value"
            item-text="text"
            prepend-icon="mdi-transit-skip"
            persistent-hint
            outlined
            :error-messages="errors"
            :readonly="dataHomologacao ? false : true"
          />
        </validation-provider>
      </v-col>
      <v-col cols="6">
        <date-picker
          v-model="atualizarAte"
          label="Atualizar Até"
          type="month"
          :rules="atualizarAte && dataAtualizarAteValida ? 'required' : 'required|forcar_erro'"
          outlined
        />
      </v-col>
    </v-row>

    <v-divider class="mb-4" />

    <v-expansion-panels v-model="panel">
      <v-expansion-panel>
        <v-expansion-panel-header id="arquivo-baixas-movimentacao-blindada">
          <span style="font-size: 15px !important">Simulação de Baixas</span>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
          <v-row class="mx-auto">
            <v-col cols="12">
              <validation-provider id="origem-simulacao-baixas" v-slot="{ errors }" rules="required">
                <v-select
                  v-model="origemBaixas"
                  label="Origem dos Dados"
                  item-value="value"
                  item-text="text"
                  no-gutters
                  outlined
                  :items="origemBaixasList"
                  :error-messages="errors"
                  @change="clearInputOrigemBaixas()"
                />
              </validation-provider>
            </v-col>
          </v-row>

          <v-row v-if="origemBaixas === 'SIMULACAO'" class="mx-auto">
            <v-col id="execucao-simulacao-baixas" cols="12" class="pl-2 pt-0">
              <validation-provider v-slot="{ errors }" rules="required">
                <v-text-field
                  label="Resultado de Simulação de Baixas"
                  placeholder="Selecione um resultado"
                  outlined
                  readonly
                  :value="simulacaoBaixasLabel"
                  :error-messages="errors"
                  @focus.close="dialogSeletorSimulacaoBaixas = true"
                />
              </validation-provider>
              <dialog-seletor-simulacao-baixas
                :activated.sync="dialogSeletorSimulacaoBaixas"
                origem="LAUDO_BLINDADO"
                :data-base="anoMesCorteUltimoCiclo"
                @selected="setSimulacaoBaixas($event)"
              />
            </v-col>
          </v-row>

          <v-row v-else-if="origemBaixas === 'CSV'">
            <v-col cols="12">
              <v-alert dense outlined type="info" color="blue">
                <div>
                  <a href="javascript:void(0)" @click="getArquivoModelo()">Clique aqui</a>
                  para baixar o modelo para a importação.
                  <br />
                  OBS: O arquivo deve conter as seguintes colunas:
                  <b>{{ cabecalhoArquivoBaixas.join(', ') }}</b>
                  (exatamente nessa ordem e com esses nomes).
                  <br />
                  OBS²: O arquivo enviado precisa estar no formato
                  <b>UTF-8</b>
                  .
                </div>
              </v-alert>
            </v-col>
            <v-col cols="12">
              <validation-provider v-slot="{ errors }" rules="required">
                <v-file-input
                  v-model="arquivoBaixasFileObj"
                  label="Arquivo CSV"
                  placeholder="Selecione um arquivo CSV"
                  outlined
                  accept=".csv, .zip"
                  truncate-length="30"
                  :loading="arquivoBaixasUploading"
                  loader-height="4"
                  :success="arquivoBaixasId && arquivoBaixasFileObj ? true : false"
                  :error-messages="errors"
                  @change="uploadNewFile($event)"
                  @click:clear="clearInputsArquivoBaixas()"
                />
              </validation-provider>
              <validation-provider rules="required">
                <input type="hidden" name="validate-upload-arquivo-baias" :value="arquivoBaixasId" />
              </validation-provider>
            </v-col>
            <v-col cols="12" class="pl-n1 pt-0">
              <parametros-arquivo-csv
                :delimitador.sync="arquivoBaixasDelimitador"
                :involucro.sync="arquivoBaixasInvolucro"
                :escape.sync="arquivoBaixasEscape"
              />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-divider class="mb-4" />

    <v-expansion-panels v-model="panelIa">
      <v-expansion-panel>
        <v-expansion-panel-header id="arquivo-ia-projecao-brr">
          <span style="font-size: 15px !important">Arquivo IA</span>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
          <v-row>
            <v-col cols="12">
              <v-alert dense outlined type="info" color="blue">
                <div>
                  <a href="javascript:void(0)" @click="getArquivoModeloIA()">Clique aqui</a>
                  para baixar o modelo para a importação.
                  <br />
                  OBS: O arquivo deve conter as seguintes colunas:
                  <b>{{ cabecalhoArquivoIa.join(', ') }}</b>
                  (exatamente nessa ordem e com esses nomes).
                  <br />
                  OBS²: O arquivo enviado precisa estar no formato
                  <b>UTF-8</b>
                  .
                </div>
              </v-alert>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <validation-provider v-slot="{ errors }">
                <v-file-input
                  v-model="arquivoIaFileObj"
                  label="Arquivo CSV"
                  placeholder="Selecione um arquivo CSV"
                  outlined
                  accept=".csv, .zip"
                  truncate-length="30"
                  :loading="arquivoIaUploading"
                  loader-height="4"
                  :success="arquivoIaId && arquivoIaFileObj ? true : false"
                  :error-messages="errors"
                  @change="uploadNewFileIa($event)"
                  @click:clear="clearInputsArquivoIa()"
                />
              </validation-provider>
              <validation-provider>
                <input type="hidden" name="validate-upload-arquivo-ia" :value="arquivoIaId" />
              </validation-provider>
            </v-col>
          </v-row>
          <v-row class="mb-n5 mt-n2 mx-auto">
            <v-col cols="12" class="pl-n1 pt-0">
              <parametros-arquivo-csv
                :delimitador.sync="arquivoIaDelimitador"
                :involucro.sync="arquivoIaInvolucro"
                :escape.sync="arquivoIaEscape"
              />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
  import dayjs from 'dayjs';
  import AtualizacaoIndicesService from '@/services/AtualizacaoIndicesService';
  import ArquivosService from '@/services/ArquivosService';
  import MovimentacaoBlindadaService from '@/services/MovimentacaoBlindadaService';

  export default {
    components: {
      DatePicker: () => import('@/components/general/DatePicker.vue'),
      ParametrosArquivoCsv: () => import('@/components/general/GeneralParametrosArquivoCsv.vue'),
      DialogSeletorSimulacaoBaixas: () => import('@/components/general/selectors/GeneralDialogSeletorSimulacaoBaixas.vue')
    },

    data: () => ({
      dataUltimoIpcaOficial: null,
      dataUltimoIpcaNaoOficial: null,
      dataHomologacaoValida: true,
      dataAtualizarAteValida: true,
      panel: false,
      panelIa: false,
      cabecalhoArquivoBaixas: [
        'ID',
        'IMOBILIZADO',
        'SUBNUMERO',
        'IDUC',
        'ODI',
        'TI',
        'TUC',
        'A1',
        'A2',
        'A3',
        'A4',
        'A5',
        'A6',
        'UAR',
        'QTD'
      ],
      cabecalhoArquivoIa: ['ODI', 'IAS', 'IAT'],
      mesesSemAtualizarIpcaOficial: 0,
      origemBaixasList: [
        {
          text: 'SIMULAÇÃO DE BAIXAS',
          value: 'SIMULACAO'
        },
        {
          text: 'ARQUIVO DE BAIXAS',
          value: 'CSV'
        }
      ],
      dialogSeletorSimulacaoBaixas: false
    }),

    computed: {
      titulo: {
        get() {
          return this.$store.state.movimentacaoBlindada.titulo;
        },
        set(value) {
          this.$store.dispatch('setMovimentacaoBlindada', { titulo: value });
        }
      },
      anoMesCorteUltimoCiclo: {
        get() {
          return this.$store.state.movimentacaoBlindada.anoMesCorteUltimoCiclo;
        },
        set(value) {
          this.$store.dispatch('setMovimentacaoBlindada', {
            anoMesCorteUltimoCiclo: value
          });
        }
      },
      dataHomologacao: {
        get() {
          return this.$store.state.movimentacaoBlindada.dataHomologacao;
        },
        set(value) {
          this.$store.dispatch('setMovimentacaoBlindada', {
            dataHomologacao: value
          });
        }
      },
      atualizarAte: {
        get() {
          return this.$store.state.movimentacaoBlindada.atualizarAte;
        },
        set(value) {
          this.$store.dispatch('setMovimentacaoBlindada', {
            atualizarAte: value
          });
        }
      },
      atualizarDesdeList: {
        get() {
          return this.$store.state.movimentacaoBlindada.atualizarDesdeList;
        }
      },
      atualizarDesde: {
        get() {
          return this.$store.state.movimentacaoBlindada.atualizarDesde;
        },
        set(value) {
          this.$store.dispatch('setMovimentacaoBlindada', {
            atualizarDesde: value
          });
        }
      },
      arquivoBaixasId: {
        get() {
          return this.$store.state.movimentacaoBlindada.arquivoBaixas.id;
        },
        set(value) {
          this.$store.dispatch('setMovimentacaoBlindada', {
            arquivoBaixas: { id: value }
          });
        }
      },
      arquivoBaixasFileObj: {
        get() {
          return this.$store.state.movimentacaoBlindada.arquivoBaixas.fileObj;
        },
        set(value) {
          this.$store.dispatch('setMovimentacaoBlindada', {
            arquivoBaixas: { fileObj: value }
          });
        }
      },
      arquivoBaixasUploading: {
        get() {
          return this.$store.state.movimentacaoBlindada.arquivoBaixas.uploading;
        },
        set(value) {
          this.$store.dispatch('setMovimentacaoBlindada', {
            arquivoBaixas: { uploading: value }
          });
        }
      },
      arquivoBaixasDelimitador: {
        get() {
          return this.$store.state.movimentacaoBlindada.arquivoBaixas.delimitador;
        },
        set(value) {
          this.$store.dispatch('setMovimentacaoBlindada', {
            arquivoBaixas: { delimitador: value }
          });
        }
      },
      arquivoBaixasInvolucro: {
        get() {
          return this.$store.state.movimentacaoBlindada.arquivoBaixas.involucro;
        },
        set(value) {
          this.$store.dispatch('setMovimentacaoBlindada', {
            arquivoBaixas: { involucro: value }
          });
        }
      },
      arquivoBaixasEscape: {
        get() {
          return this.$store.state.movimentacaoBlindada.arquivoBaixas.escape;
        },
        set(value) {
          this.$store.dispatch('setMovimentacaoBlindada', {
            arquivoBaixas: { escape: value }
          });
        }
      },
      arquivoBaixasFakeFile: {
        get() {
          return this.$store.state.movimentacaoBlindada.arquivoBaixas.fakeFile;
        },
        set(value) {
          this.$store.dispatch('setMovimentacaoBlindada', {
            arquivoBaixas: { fakeFile: value }
          });
        }
      },
      arquivoBaixasHeaderValido: {
        get() {
          return this.$store.state.movimentacaoBlindada.arquivoBaixas.headerValido;
        },
        set(value) {
          this.$store.dispatch('setMovimentacaoBlindada', {
            arquivoBaixas: { headerValido: value }
          });
        }
      },
      arquivoIaId: {
        get() {
          return this.$store.state.movimentacaoBlindada.arquivoIa.id;
        },
        set(value) {
          this.$store.dispatch('setMovimentacaoBlindada', {
            arquivoIa: { id: value }
          });
        }
      },
      arquivoIaFileObj: {
        get() {
          return this.$store.state.movimentacaoBlindada.arquivoIa.fileObj;
        },
        set(value) {
          this.$store.dispatch('setMovimentacaoBlindada', {
            arquivoIa: { fileObj: value }
          });
        }
      },
      arquivoIaUploading: {
        get() {
          return this.$store.state.movimentacaoBlindada.arquivoIa.uploading;
        },
        set(value) {
          this.$store.dispatch('setMovimentacaoBlindada', {
            arquivoIa: { uploading: value }
          });
        }
      },
      arquivoIaDelimitador: {
        get() {
          return this.$store.state.movimentacaoBlindada.arquivoIa.delimitador;
        },
        set(value) {
          this.$store.dispatch('setMovimentacaoBlindada', {
            arquivoIa: { delimitador: value }
          });
        }
      },
      arquivoIaInvolucro: {
        get() {
          return this.$store.state.movimentacaoBlindada.arquivoIa.involucro;
        },
        set(value) {
          this.$store.dispatch('setMovimentacaoBlindada', {
            arquivoIa: { involucro: value }
          });
        }
      },
      arquivoIaEscape: {
        get() {
          return this.$store.state.movimentacaoBlindada.arquivoIa.escape;
        },
        set(value) {
          this.$store.dispatch('setMovimentacaoBlindada', {
            arquivoIa: { escape: value }
          });
        }
      },
      origemBaixas: {
        get() {
          return this.$store.state.movimentacaoBlindada.origemBaixas;
        },
        set(value) {
          this.$store.dispatch('setMovimentacaoBlindada', {
            origemBaixas: value
          });
        }
      },
      simulacaoBaixasId: {
        get() {
          return this.$store.state.movimentacaoBlindada.simulacaoBaixas.id;
        },
        set(value) {
          this.$store.dispatch('setMovimentacaoBlindada', {
            simulacaoBaixas: {
              id: value
            }
          });
        }
      },
      simulacaoBaixasNome: {
        get() {
          return this.$store.state.movimentacaoBlindada.simulacaoBaixas.nome;
        },
        set(value) {
          this.$store.dispatch('setMovimentacaoBlindada', {
            simulacaoBaixas: {
              nome: value
            }
          });
        }
      },
      simulacaoBaixasLabel() {
        return this.simulacaoBaixasId ? `#${this.simulacaoBaixasId} - ${this.simulacaoBaixasNome}` : '';
      }
    },

    created() {
      this.getUltimoIndice();
    },

    mounted() {
      if (this.$route.params.id) this.abrirPainel();
    },

    methods: {
      exportData() {
        const vuexData = this.$store.state.movimentacaoBlindada;

        return {
          id: this.$route.params.id ? this.$route.params.id : null,
          titulo: vuexData.titulo,
          ano_mes_corte_ultimo_ciclo: vuexData.anoMesCorteUltimoCiclo,
          data_homologacao: vuexData.dataHomologacao,
          atualizar_desde: vuexData.atualizarDesde,
          atualizar_ate: vuexData.atualizarAte,
          arquivo_baixas_id: vuexData.arquivoBaixas.id,
          arquivo_baixas_delimitador: vuexData.arquivoBaixas.delimitador,
          arquivo_baixas_involucro: vuexData.arquivoBaixas.involucro,
          arquivo_baixas_escape: vuexData.arquivoBaixas.escape,
          arquivo_ia_id: vuexData.arquivoIa.id,
          arquivo_ia_delimitador: vuexData.arquivoIa.delimitador,
          arquivo_ia_involucro: vuexData.arquivoIa.involucro,
          arquivo_ia_escape: vuexData.arquivoIa.escape,
          origem_baixas: vuexData.origemBaixas,
          simulacao_baixas_id: vuexData.simulacaoBaixas.id
        };
      },

      getUltimoIndice() {
        AtualizacaoIndicesService.getUltimoIndiceIpca()
          .then((indice) => {
            this.dataUltimoIpcaOficial = indice.indice_oficial ? indice.indice_oficial.DataRegistro : '';
            this.dataUltimoIpcaNaoOficial = indice.indice_estimado ? indice.indice_estimado.DataRegistro : '';

            let dataAtual = dayjs();
            let qtdMeses = dataAtual.diff(dayjs(this.dataUltimoIpcaOficial), 'month');
            this.mesesSemAtualizarIpcaOficial = qtdMeses;
          })
          .catch(() =>
            this.$toast.error('Erro ao buscar ultimo Índice IPCA.', '', {
              position: 'topRight'
            })
          );
      },

      validarDataContempladaIPCA(data) {
        if (!data) return false;

        const dataReferencia = dayjs(data);
        const dataIpca = this.dataUltimoIpcaNaoOficial || this.dataUltimoIpcaOficial;
        if (dataReferencia.isAfter(dataIpca)) {
          this.$toast.error('Erro: A data de referência está incorreta, confira o ultimo IPCA .', '', { position: 'topRight' });
          return false;
        }

        return true;
      },

      checkAtualizarDesdeInput() {
        if (!this.dataHomologacao) this.atualizarDesde = 'DATA_CORTE_ULTIMO_CICLO';
      },

      getArquivoModelo() {
        this.$toast.info('Processando...', '', {
          position: 'topRight',
          timeout: 1250
        });

        MovimentacaoBlindadaService.getArquivoModelo()
          .then(async (res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;

            link.setAttribute('download', 'Arquivo Baixas Modelo.csv');
            document.body.appendChild(link);
            link.click();
          })
          .catch((err) => {
            this.$toast.error('Erro ao baixar arquivo modelo do sistema', '', {
              position: 'topRight'
            });
            console.error(err);
          });
      },

      getArquivoModeloIA() {
        this.$toast.info('Processando...', '', {
          position: 'topRight',
          timeout: 1250
        });

        MovimentacaoBlindadaService.getArquivoModeloIA()
          .then(async (res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;

            link.setAttribute('download', 'Arquivo IA Modelo.csv');
            document.body.appendChild(link);
            link.click();
          })
          .catch((err) => {
            this.$toast.error('Erro ao baixar arquivo modelo do sistema', '', {
              position: 'topRight'
            });
            console.error(err);
          });
      },

      uploadNewFile(arquivo) {
        if (!arquivo) {
          this.clearInputsArquivoBaixas();
          return true;
        }

        this.arquivoBaixasFakeFile = false;
        this.arquivoBaixasId = '';
        this.arquivoBaixasUploading = true;

        let formDataWithFile = new FormData();
        formDataWithFile.append('file', arquivo);

        ArquivosService.uploadFile(formDataWithFile)
          .then(async (response) => {
            await this.validaHeader(
              response.data.arquivoId,
              this.arquivoBaixasDelimitador,
              this.arquivoBaixasInvolucro,
              this.arquivoBaixasEscape,
              this.cabecalhoArquivoBaixas
            );
            this.arquivoBaixasId = response.data.arquivoId;
          })
          .catch((err) => {
            if (err?.data?.error_code == 120 || err?.data?.error_code == 121) {
              this.$toast.error(err.data.erro, '', {
                position: 'topRight',
                timeout: 6000
              });
            } else {
              this.$toast.error('Erro no upload do arquivo.', '', {
                position: 'topRight'
              });
              console.error('Erro ao fazer upload: ', err);
            }

            this.arquivoBaixasFileObj = null;
          })
          .finally(() => (this.arquivoBaixasUploading = false));
      },

      validaHeader(arquivoId, delimitador, involucro, escape, cabecalhoEsperado) {
        return ArquivosService.validarHeaderCSV(arquivoId, {
          delimitador,
          involucro,
          escape,
          cabecalhoEsperado
        }).catch((err) => {
          throw err;
        });
      },

      uploadNewFileIa(arquivo) {
        if (!arquivo) {
          this.clearInputsArquivoIa();
          return true;
        }

        this.arquivoIaId = '';
        this.arquivoIaUploading = true;

        let formDataWithFile = new FormData();
        formDataWithFile.append('file', arquivo);

        ArquivosService.uploadFile(formDataWithFile, {})
          .then(async (response) => {
            await this.validaHeader(
              response.data.arquivoId,
              this.arquivoIaDelimitador,
              this.arquivoIaInvolucro,
              this.arquivoIaEscape,
              this.cabecalhoArquivoIa
            );
            this.arquivoIaId = response.data.arquivoId;
          })
          .catch((err) => {
            if (err?.data?.error_code == 120 || err?.data?.error_code == 121) {
              this.$toast.error(err.data.erro, '', {
                position: 'topRight',
                timeout: 6000
              });
            } else {
              this.$toast.error('Erro no upload do arquivo.', '', {
                position: 'topRight'
              });
              console.error('Erro ao fazer upload: ', err);
            }

            this.arquivoIaFileObj = null;
          })
          .finally(() => (this.arquivoIaUploading = false));
      },

      clearInputsArquivoBaixas() {
        this.arquivoBaixasId = '';
        this.arquivoBaixasFileObj = null;
        this.arquivoBaixasDelimitador = ';';
        this.arquivoBaixasInvolucro = '"';
        this.arquivoBaixasEscape = '"';
        this.arquivoBaixasFakeFile = false;
        this.arquivoBaixasHeaderValido = false;

        this.$forceUpdate();
      },

      clearInputsArquivoIa() {
        this.arquivoIaId = '';
        this.arquivoIaFileObj = null;
        this.arquivoIaDelimitador = ';';
        this.arquivoIaInvolucro = '"';
        this.arquivoIaEscape = '"';

        this.$forceUpdate();
      },

      abrirPainel() {
        this.panel = 0;
        this.panelIa = 0;
      },

      formatDate(date, tipo) {
        if (!date) return null;
        if (date && date.length > 10) date = date.substr(0, 10);

        return tipo == 'month' ? dayjs(date).format('MM/YYYY') : dayjs(date).format('YYYY-MM-DD');
      },

      setSimulacaoBaixas(simulacao) {
        this.simulacaoBaixasId = simulacao.id;
        this.simulacaoBaixasNome = simulacao.nome;
        this.dialogSeletorSimulacaoBaixas = false;
      },

      clearSimulacaoBaixas() {
        this.setSimulacaoBaixas({
          id: null,
          nome: ''
        });
      },

      clearInputOrigemBaixas() {
        this.clearInputsArquivoBaixas();
        this.clearSimulacaoBaixas();
      }
    },

    watch: {
      dataHomologacao(newDate) {
        let dataValida = this.validarDataContempladaIPCA(newDate);
        this.dataHomologacaoValida = dataValida;
      },

      atualizarAte(newDate) {
        let dataValida = this.validarDataContempladaIPCA(newDate);
        this.dataAtualizarAteValida = dataValida;
      }
    }
  };
</script>
